/**
 * Status indicator badge component with color-coded styling.
 * Uses statusUtils for consistent color mapping across different status types.
 * Supports different status types (call, enrollment, etc.) and custom styling.
 * Used in CallSessionSidebar and CallSessionMetrics for status display.
 */

// src/components/common/StatusBadge.jsx
import React from 'react';
import { getStatusColor } from '../../utils/statusUtils';

const StatusBadge = ({
  status,
  type = 'call',
  className = '',
  showText = true
}) => {
  // Handle different data types for status
  const getDisplayText = (status) => {
    if (typeof status === 'string') {
      return status.charAt(0).toUpperCase() + status.slice(1);
    }
    if (typeof status === 'object' && status !== null) {
      // Handle role objects
      if (status.role_name) return status.role_name;
      if (status.name) return status.name;
      if (status.role) return status.role;
    }
    return 'N/A';
  };

  const colorClass = getStatusColor(status, type);
  const displayText = getDisplayText(status);

  return (
    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${colorClass} ${className}`}>
      {showText && displayText}
    </span>
  );
};

export default StatusBadge;